
/**
 * Central repository for template variables that can be used across the application
 */

/**
 * List of available template variables with descriptions
 */
export const TEMPLATE_VARIABLES = [
    { name: "email.subject", description: "Subject line of the email" },
    { name: "email.receivedAt", description: "Time when email was received in UTC" },
    { name: "email.sender.address", description: "Email address of the sender" },
    { name: "email.sender.name", description: "Name of the email sender (if available)" },

    { name: "mailbox.email", description: "Email address of the mailbox." },
    { name: "mailbox.user.name", description: "Name of the user associated with the mailbox." },
  ];
  
  /**
   * Get a flat list of variable names
   */
  export const getVariableNames = (): string[] => {
    return TEMPLATE_VARIABLES.map(variable => variable.name);
  };
  
  /**
   * Get variable description by name
   */
  export const getVariableDescription = (name: string): string | undefined => {
    const variable = TEMPLATE_VARIABLES.find(v => v.name === name);
    return variable?.description;
  };
  
  /**
   * Group variables by category
   */
  export const getVariablesByCategory = () => {
    const categories: Record<string, typeof TEMPLATE_VARIABLES> = {};
    
    TEMPLATE_VARIABLES.forEach(variable => {
      // Extract category from variable name (part before first dot)
      const category = variable.name.split('.')[0];
      
      if (!categories[category]) {
        categories[category] = [];
      }
      
      categories[category].push(variable);
    });
    
    return categories;
  };
  